import React from 'react';
import { HOME_LOANS_ABOUT_MORTGAGE } from 'types/morph.pagePosition.constants';
import { useViewModule, useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import AboutMortgagesModuleView from './AboutMortgagesModuleView';
import { CLICK } from 'externals/_tracking/mixpanel/types/Mixpanel.event.types';
import { MORTGAGE_VERTICAL } from 'types/mrph.vertical.constants';
import { TABS_TYPE } from '../../HomeLoanMarketplaceModule/helpers/homeLoan.helpers';

const AboutMortgagesModuleController = props => {
  const atr = getViewModuleTrackingAttributes(
    HOME_LOANS_ABOUT_MORTGAGE,
    props.modulePosition,
  );

  useViewModule(atr);
  const seenPixel = useSeenModulePixel(atr);

  const onClickGotoCalculator = () => {
    props.setActiveTab('monthlyPaymentCalculator');
    props.history.push(TABS_TYPE['monthlyPaymentCalculator']?.path);
    props.eventHandler(CLICK, {
      'Click Type': 'Calculate Monthly Payments',
      'Page Position': HOME_LOANS_ABOUT_MORTGAGE,
      'Module Position': props.modulePosition,
      Vertical: MORTGAGE_VERTICAL,
    });
  };

  return (
    <AboutMortgagesModuleView
      {...props}
      seenPixel={seenPixel}
      onClickGotoCalculator={onClickGotoCalculator}
    />
  );
};

export default AboutMortgagesModuleController;
